import { render, staticRenderFns } from "./DocumentIcdCodesTabContent.vue?vue&type=template&id=7ead41e0&scoped=true&"
import script from "./DocumentIcdCodesTabContent.vue?vue&type=script&lang=js&"
export * from "./DocumentIcdCodesTabContent.vue?vue&type=script&lang=js&"
import style0 from "./DocumentIcdCodesTabContent.vue?vue&type=style&index=0&id=7ead41e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ead41e0",
  null
  
)

export default component.exports